<script setup>
import { get, post } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { useMetaStore } from '@/stores'
import { onMounted, reactive } from 'vue'
import _ from 'lodash-es'

const metaStore=useMetaStore(),meta=reactive({confs:{},etckeys:['vwapikey','vwdomain','navermapidapi','navermapkey','kakaomapkey']})
,pop=async(type,ttl)=>{
  meta.poptype=null
  meta.popttl=ttl
  metaStore.pop({callback:()=>{
    meta.poptype=type
  },ison:type!=null,persist:false})
},saveConf=async(ttl,wkey,poptype)=>{
  meta.wkey=wkey
  pop(poptype,ttl)
},saveReq=async()=>{
  metaStore.blockLoading()
  let res
  if(meta.poptype=='clearuptmp'){
    res=await get('rest/authed/admin/clearuptmp')
  }else if(meta.poptype=='clearsvorphans'){
    res=await get('rest/authed/admin/clearsvorphans')
  }else if(meta.etckeys.includes(meta.wkey)){
    res=await post('rest/authed/admin/saveconf',{wkey:meta.wkey,sval:meta.confs[meta.wkey]})
  }
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
},mountDisk=async()=>{
  metaStore.blockLoading()
  const res=await get('rest/authed/admin/mountmedia')
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
},unmountDisk=async()=>{
  metaStore.blockLoading()
  const res=await get('rest/authed/admin/unmountmedia')
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
},killallsvbackproc=async()=>{
  if(!confirm('현재 실행 중인 모든 거리뷰 독립 프로세스를 종료합니다.\n계속하시겠습니까?'))return
  metaStore.blockLoading()
  const res=await get('rest/authed/admin/killallsvbackproc')
  setTimeout(async()=>{
    await init()
    metaStore.blockLoading(false)
    metaStore.toastRslt(res,true)

  },500)
},init=async()=>{
  _.keys(meta.confs).forEach(k=>delete meta.confs[k])
  let res=await get('rest/authed/member/confswkeyin/'+meta.etckeys.join(','))
  res.data.forEach(conf=>meta.confs[conf.wkey]=conf.sval)
  res=await get('rest/authed/admin/currentupsvprocs')
  meta.currentupsvprocs=res.data
}
onMounted(()=>{
  init()
})
</script>
<template>
  <v-card elevation="0" :title="$t('etc_config')">
    <v-card-text>
      <v-defaults-provider :defaults="{VTextField:{hideDetails:true,variant:'outlined',density:'compact',noGutters:true}}">
      <v-btn @click="init">새로고침</v-btn>
      <p>{{ $t('vworld')+' '+$t('aboutapikeys')}}</p>
      <v-row>
        <v-col>
          <v-text-field v-model="meta.confs.vwapikey"/>
        </v-col>
        <v-col><v-btn color="primary" :text="$t('save')" @click="saveConf($t('vworld')+' '+$t('aboutapikeys'),'vwapikey','savecon')"/></v-col>
      </v-row>
      <p>{{ $t('vworld')+' '+$t('domain')}}</p>
      <v-row>
        <v-col>
          <v-text-field v-model="meta.confs.vwdomain"/>
        </v-col>
        <v-col><v-btn color="primary" :text="$t('save')" @click="saveConf($t('vworld')+' '+$t('domain'),'vwdomain','savecon')"/></v-col>
      </v-row>
      <p>NAVER 지도 API 키 ID [Client ID(X-NCP-APIGW-API-KEY-ID)](도메인 등록은 NAVER 에서 설정가능)</p>
      <v-row>
        <v-col>
          <v-text-field v-model="meta.confs.navermapidapi"/>
        </v-col>
        <v-col><v-btn color="primary" :text="$t('save')" @click="saveConf('NAVER 지도 API 키 ID','navermapidapi','savecon')"/></v-col>
      </v-row>
      <p>NAVER 지도 API 키[Client Secret(X-NCP-APIGW-API-KEY)](도메인 등록은 NAVER 에서 설정가능)</p>
      <v-row>
        <v-col>
          <v-text-field v-model="meta.confs.navermapkey"/>
        </v-col>
        <v-col><v-btn color="primary" :text="$t('save')" @click="saveConf('NAVER 지도 API 키','navermapkey','savecon')"/></v-col>
      </v-row>
      <p>KAKAO 지도 API 키(도메인 등록은 KAKAO 에서 설정가능)</p>
      <v-row>
        <v-col>
          <v-text-field v-model="meta.confs.kakaomapkey"/>
        </v-col>
        <v-col><v-btn color="primary" :text="$t('save')" @click="saveConf('KAKAO 지도 API 키','kakaomapkey','savecon')"/></v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex">
            <table class="mr-10 border-thin">
              <tbody>
                <tr>
                  <td><p>서버 임시 업로드 파일 삭제(5일 전 파일만)</p></td>
                  <td><v-btn density="compact" variant="outlined" :text="$t('execute')" @click="pop('clearuptmp','서버 임시 업로드 파일 삭제(5일 전 파일만)')"/></td>
                </tr>
              </tbody>
            </table>
            <table class="mr-10 border-thin">
              <tbody>
                <tr>
                  <td><p>오류난 거리뷰 데이터 제거</p></td>
                  <td><v-btn density="compact" variant="outlined" :text="$t('execute')" @click="pop('clearsvorphans','연결 끊긴 거리뷰 파일 제거')"/></td>
                </tr>
              </tbody>
            </table>
            <table class="mr-10 border-thin">
              <tbody>
                <tr>
                  <td><p>현재 실행 중 거리뷰 업로드 독립 프로세스:</p></td>
                  <td>{{meta.currentupsvprocs?.length}}</td>
                  <td><v-btn block density="compact" variant="outlined" text="모두 종료" @click="killallsvbackproc()"/></td>
                </tr>
              </tbody>
            </table>
            <table class="mr-10 border-thin">
              <tbody>
                <tr>
                  <td><v-btn block density="compact" variant="outlined" text="외장디스크연결" @click="mountDisk()"/></td>
                  <td><v-btn block density="compact" variant="outlined" text="외장디스크해지" @click="unmountDisk()"/></td>
                </tr>
              </tbody>
            </table>
        </v-col>
      </v-row>
    </v-defaults-provider>
  </v-card-text>
</v-card>
<Teleport v-if="meta.poptype" to="#popbody">
  <ConfirmCard :ttl="meta.popttl" cont="save" @cancel="pop()" @confirm="saveReq"/>
</Teleport>
</template>
